const DATE_FMT = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
});

const DATETIME_FMT = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** Parse an ISO date, rejecting empty/invalid and backend zero-dates (year < 1971). */
function parseDate(iso: string | undefined | null): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime()) || d.getFullYear() < 1971) return null;
  return d;
}

export function formatDate(iso: string | undefined | null): string {
  const d = parseDate(iso);
  return d ? DATE_FMT.format(d) : '—';
}

export function formatDateTime(iso: string | undefined | null): string {
  const d = parseDate(iso);
  return d ? DATETIME_FMT.format(d) : '—';
}
